/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Existing Assembly webhook payload, verified against its authoritative job.
 */
export type AssemblyAIWebhookParams = {
    /**
     * Submitted provider job identity.
     */
    transcript_id?: string;
    /**
     * Provider completion state.
     */
    status: AssemblyAIWebhookParams.status;
    /**
     * Untrusted diagnostic; never forwarded to logs.
     */
    error?: string;
};
export namespace AssemblyAIWebhookParams {
    /**
     * Provider completion state.
     */
    export enum status {
        COMPLETED = 'completed',
        ERROR = 'error',
    }
}

